// utils/urlUtils.js
export const updateURLFilters = (searchParams, setSearchParams, newFilters) => {
    const params = new URLSearchParams(searchParams);
  
    for (const [key, value] of Object.entries(newFilters)) {
      if (Array.isArray(value) && value.length > 0) {
        params.set(key, value.join(',')); // Convert array to comma-separated string
      } else if (value !== undefined && value !== null && value !== '') {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    }
  
    setSearchParams(params);
  };
  